// dashboard/src/components/Interact/VideoPreview.tsx
import React, { FC, useEffect, useRef } from 'react';

interface VideoPreviewProps {
  stream: MediaStream | null;
}

const VideoPreview: FC<VideoPreviewProps> = ({ stream }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const startPlayback = () => {
    if (videoRef.current && stream) {
      if (videoRef.current.paused) {
        videoRef.current.srcObject = stream;
        videoRef.current.play().catch((error) => {
          console.error('Failed to start video playback:', error);
        });
      }
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (video && stream) {
      video.srcObject = stream;
    }
    // Drop the element's reference so it never keeps a released stream alive.
    return () => {
      if (video) video.srcObject = null;
    };
  }, [stream]);

  return (
    <div
      className="video-preview"
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {stream && (
        <video
          onClick={startPlayback}
          ref={videoRef}
          autoPlay
          muted
          playsInline
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      )}
      {!stream && <p>No media stream available</p>}
    </div>
  );
};

export default VideoPreview;
